module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-flex', {
    staticClass: "px-4",
    attrs: {
      "xs12": "",
      "sm10": "",
      "md7": "",
      "lg5": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompany,
      "readonly": _vm.isEdit,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.companyId),
      callback: function($$v) {
        _vm.companyId = $$v
      },
      expression: "companyId"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-4",
    attrs: {
      "disabled": _vm.editingMap
    },
    on: {
      "click": _vm.addMapping
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.addLangMapp))]), _vm._v(" "), _c('div', {
    staticClass: "v-table__overflow my-3 px-4"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('tbody', _vm._l((_vm.maps), function(map, index) {
    return _c('tr', {
      key: index
    }, [(map.isEdit) ? [_c('td', [_c('v-select', {
      staticClass: "min-w",
      attrs: {
        "required": "",
        "items": _vm.printerCategories,
        "label": _vm.$lang.actions.selectPrinterCategory
      },
      model: {
        value: (_vm.tempMapping.categoryName),
        callback: function($$v) {
          _vm.$set(_vm.tempMapping, "categoryName", $$v)
        },
        expression: "tempMapping.categoryName"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-select', {
      staticClass: "min-w",
      attrs: {
        "required": "",
        "items": _vm.languages,
        "item-text": "text",
        "item-value": "value",
        "label": _vm.$lang.actions.selectLanguage
      },
      model: {
        value: (_vm.tempMapping.language),
        callback: function($$v) {
          _vm.$set(_vm.tempMapping, "language", $$v)
        },
        expression: "tempMapping.language"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "min-w-lg px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.tempMapping.language || !_vm.tempMapping.categoryName
      },
      on: {
        "click": function($event) {
          return _vm.saveMappingEdit(map)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.save))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closeMappingEdit(map)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.cancel))])], 1)] : [_c('td', [_vm._v(_vm._s(map.categoryName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(map.language))]), _vm._v(" "), _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      on: {
        "click": function($event) {
          return _vm.editMapping(map)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.deleteMapping(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.delete))])], 1)]], 2)
  }), 0)])]), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-content-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-3",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'languageMappings'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-3",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10d0e77f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/languageMappings/LanguageMappingDetails.vue
// module id = 386
// module chunks = 35